// This icon file is generated automatically.
var PRightSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M5.45 9.88L9.29 7.1a.12.12 0 000-.2L5.45 4.12a.13.13 0 00-.2.1v.73c0 .16.08.31.2.4L7.74 7 5.46 8.64a.5.5 0 00-.21.4v.74c0 .1.12.16.2.1z" } }, { "tag": "path", "attrs": { "d": "M12.75.75H1.25a.5.5 0 00-.5.5v11.5c0 .28.22.5.5.5h11.5a.5.5 0 00.5-.5V1.25a.5.5 0 00-.5-.5zm-.63 11.38H1.88V1.87h10.25v10.25z" } }] }] }, "name": "p-right-square", "theme": "outlined" };
export default PRightSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PRightSquareOutlined.js
// module id = 3603
// module chunks = 0